import { render } from "./Icons.vue?vue&type=template&id=eb0de9bc"
const script = {}

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__